//
// objectsIdentical
//
// Compares two objects, looks at 'depth' levels of keys.
// After 'depth' levels, objects are presumed identical.
//

// import displayJson from './displayJson';

const objectsIdentical = (firstObject, secondObject, depth = 1) => {
  // console.log(`objectsIdentical firstObject=${
  //   displayJson(firstObject)} secondObject=${
  //   displayJson(secondObject)} respectOrder=${
  //   depth}`);

  if (((typeof firstObject) !== 'object') || (firstObject === null)) {
    return (firstObject === secondObject);
  }

  if (((typeof secondObject) !== 'object') || (secondObject === null)) return false;

  if (depth === 0) return true;

  if (Object.keys(firstObject).length !== Object.keys(secondObject).length) return false;

  if (depth === 0) return (firstObject === secondObject);

  // Go through each key
  return Object
    .keys(firstObject)
    .every((key) => objectsIdentical(firstObject[key], secondObject[key], depth - 1));
};

export default objectsIdentical;
